import httpService from '../../api/httpLocationService';

import {
  RECEIVED_MARKERS,
  RECEIVED_LOCATIONS,
  MAP_CHECKBOX_UNCHANGED,
  MAP_DESELECT_ALL_CHECKBOX,
  MAP_SELECT_ALL_CHECKBOX,
} from '../constants/index';

export const receivedMarkers = response => ({
  type: RECEIVED_MARKERS,
  response,
});

export const receivedLocation = response => ({
  type: RECEIVED_LOCATIONS,
  response,
});

export const changedMapCheckbox = (id, isSelected) => ({
  type: MAP_CHECKBOX_UNCHANGED,
  id,
  isSelected,
});

export const mapDeselectAllCheckbox = () => ({
  type: MAP_DESELECT_ALL_CHECKBOX,
});

export const mapSelectAllCheckbox =() => ({
  type: MAP_SELECT_ALL_CHECKBOX,
});

export function getLocationMarkers(areaId, kind) {
  return function(dispatch) {
    httpService.getLocationsMarkers(areaId, kind)
      .then((response) => {
        dispatch(receivedMarkers(response));
      });
  };
}

export function getLocationList(areaId, page, kind) {
  return function(dispatch) {
    httpService.getLocationsList(areaId, page, kind)
      .then((response) => {
        dispatch(receivedLocation(response));
      });
  };
}

export const mapCheckBoxUnChecked = (id, isSelected) => function (dispatch) {
  dispatch(changedMapCheckbox(id, isSelected));
};

export const mapCheckBoxDeselectAll = () => function (dispatch) {
  dispatch(mapDeselectAllCheckbox());
};

export const mapCheckBoxSelectAll = () => function (dispatch) {
  dispatch(mapSelectAllCheckbox());
};